import React from 'react';
import { CheckIcon, CreditCardIcon } from 'lucide-react';
import { PRICE, PRICE_BEFORE, offerIncludes, offerRows } from '../data/spremna';
import { PRODUCT_IMAGE } from '../data/assets';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-slate-900 px-5 py-24 text-stone-50 sm:px-14 sm:py-32" data-id="element-237" data-mp="1mpd5s4kh617g">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12 lg:items-center" data-id="element-238" data-mp="1hqs5641b9fih">
        <div className="px-3 sm:px-0 lg:col-span-6" data-id="element-239" data-mp="u0xspnkwlsyr">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight sm:text-6xl" data-id="element-240" data-mp="p0jwd2so07gk">
            Цео пакет <em className="text-red-300" style={{
            hyphens: 'manual'
          }} data-id="element-241" data-mp="13y2h7u2820iq">МАТЕМАТИКА СПРЕМНА™</em>
          </h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-stone-50/70" data-id="element-242" data-mp="yx50llwv1ejc">
            Цела школска година из математике – спремна. Почните за 5 минута.
          </p>
          <img src={PRODUCT_IMAGE} alt="" className="mx-auto mt-12 hidden w-full max-w-sm drop-shadow-2xl lg:block" data-id="element-243" data-mp="2admogxme68ud" />
        </div>

        <div id="offer-card" className="scroll-mt-16 rounded-3xl bg-stone-50 p-6 text-slate-900 shadow-2xl shadow-black/40 sm:p-11 lg:col-span-6" data-id="element-244" data-mp="pjfmagfjuxlt">
          <p className="text-sm font-semibold text-slate-900/60" data-id="element-245" data-mp="zieslscueh5n">Цео пакет садржи</p>

          <ul className="mt-5 divide-y divide-slate-900/10 border-y border-slate-900/10" data-id="element-246" data-mp="zgk9mjl4sz47">
            {offerRows.map(row => <li key={row.label} className="flex gap-4 py-4" data-id="element-247" data-mp="6tpmtg0udnnk">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-700" data-id="element-248" data-mp="6vkct8qz05yi">
                  <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-249" data-mp="bqg58a04cvc5" />
                </span>
                <span data-id="element-250" data-mp="kkvw23txaznn">
                  <span className="block font-medium leading-snug" data-id="element-251" data-mp="kldyji76ia40">{row.label}</span>
                  <span className="mt-0.5 block text-sm leading-snug text-slate-900/65" data-id="element-252" data-mp="3k95jac2dyth4">{row.detail}</span>
                </span>
              </li>)}
          </ul>

          <div className="mt-8 flex flex-col items-center gap-2 text-center sm:flex-row sm:items-end sm:justify-between sm:gap-4 sm:text-left" data-id="element-253" data-mp="3o84jjjd6a228">
            <p className="text-sm font-medium text-slate-900/70 sm:pb-2" data-id="element-254" data-mp="qhfmtq8t709g">Уводна цена <s className="ml-1 text-slate-900/50" data-id="element-255" data-mp="155k6oxjllhtt">{PRICE_BEFORE}</s></p>
            <p className="whitespace-nowrap font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-256" data-mp="154qvnkdlw65v">
              {PRICE}
            </p>
          </div>
          <p className="mt-3 flex items-center justify-center gap-2 text-sm text-slate-900/70 sm:justify-end" data-id="element-257" data-mp="cho113c1wfkw">
            <CreditCardIcon className="h-4 w-4" aria-hidden="true" data-id="element-258" data-mp="7jctx0d54j6d" />
            Једнократно плаћање. Без претплате.
          </p>

          <CtaButton label="Преузмите цео пакет" className="mt-8 w-full" data-id="element-259" data-mp="lf87cqort22d" />

          <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-slate-900/60" data-id="element-260" data-mp="heo9tm0abwfp">
            {offerIncludes.map(item => <li key={item} data-id="element-261" data-mp="1sv4rzn384r69">{item}</li>)}
          </ul>
        </div>
      </div>
    </section>;
}